import React, { useState, useEffect, useRef } from 'react';
import './aichat.css';
import Welcome from './components/Welcome';

const AiChat = ({user}) => {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState('');
    const [isBotTyping, setIsBotTyping] = useState(false);
    const [pendingBotMessage, setPendingBotMessage] = useState(null);
    const inputRef = useRef(null);

    const sendIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
            <path d="M19.8036 2.34497L13.5711 16.8075C13.2663 17.5143 12.5145 17.986 11.6702 18H11.5348C10.8122 17.9327 10.2143 17.4671 10.039 16.8355L7.96181 11.869L12.6255 7.68535V7.68447C12.7803 7.55518 12.8699 7.37522 12.8728 7.18564C12.8767 6.99606 12.7949 6.81347 12.645 6.67895C12.496 6.54529 12.2924 6.47103 12.0811 6.47453C11.8688 6.47802 11.6682 6.55839 11.5241 6.69642L8.06503 9.79948L6.83994 10.8618L1.26182 8.99839C0.547025 8.82803 0.0386997 8.2628 0.00459532 7.60062C-0.0557829 6.78468 0.483727 6.02901 1.33387 5.73722L17.4557 0.146137C18.151 -0.139523 18.9719 0.00199217 19.5007 0.497324C20.0295 0.992649 20.1513 1.73431 19.8036 2.34497Z" fill="#7351FD"/>
        </svg>
    );

    const copyIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path d="M9.63914 0H4.13914C3.77822 0 3.43208 0.144584 3.17686 0.401945C2.92165 0.659306 2.77828 1.00836 2.77828 1.37233V2.70901H1.3644C1.00408 2.70806 0.658103 2.85125 0.40233 3.10717C0.146557 3.36309 0.00187054 3.71086 0 4.07421V9.62767C0.000933086 9.99135 0.144609 10.3399 0.399618 10.597C0.654627 10.8542 1.00023 10.9991 1.36086 11H6.86086C7.22178 11 7.56792 10.8554 7.82314 10.5981C8.07835 10.3407 8.22172 9.99164 8.22172 9.62767V8.29099H9.6356C9.99592 8.29194 10.3419 8.14875 10.5977 7.89283C10.8534 7.63691 10.9981 7.28914 11 6.92579V1.37233C10.9991 1.00865 10.8554 0.660142 10.6004 0.402985C10.3454 0.145827 9.99977 0.000940948 9.63914 0ZM7.13303 9.62411C7.13303 9.6969 7.10436 9.76671 7.05332 9.81818C7.00227 9.86966 6.93305 9.89857 6.86086 9.89857H1.36086C1.28896 9.89765 1.22026 9.86844 1.16942 9.81716C1.11857 9.76589 1.08961 9.69661 1.08869 9.62411V4.07421C1.08869 4.00141 1.11736 3.9316 1.16841 3.88013C1.21945 3.82866 1.28868 3.79974 1.36086 3.79974H6.86086C6.89673 3.79926 6.93234 3.80603 6.96558 3.81966C6.99881 3.83328 7.02901 3.85348 7.05438 3.87906C7.07974 3.90464 7.09977 3.93509 7.11328 3.96861C7.12679 4.00212 7.13351 4.03803 7.13303 4.07421V9.62767V9.62411ZM9.91131 6.92579C9.91131 6.96184 9.90427 6.99753 9.89059 7.03083C9.87691 7.06413 9.85687 7.09438 9.83159 7.11987C9.80632 7.14536 9.77632 7.16557 9.74329 7.17937C9.71027 7.19316 9.67488 7.20026 9.63914 7.20026H8.22526V4.07421C8.22526 3.71024 8.08188 3.36119 7.82667 3.10382C7.57146 2.84646 7.22532 2.70188 6.8644 2.70188H3.86697V1.37233C3.86697 1.29953 3.89564 1.22972 3.94668 1.17825C3.99773 1.12678 4.06695 1.09786 4.13914 1.09786H9.63914C9.71104 1.09879 9.77974 1.128 9.83058 1.17927C9.88142 1.23055 9.91039 1.29982 9.91131 1.37233V6.92579Z" fill="#7351FD"/>
        </svg>
    );

    const editIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
            <path d="M0.788067 7.7113L2.7887 9.71193L0.794496 9.99737C0.713494 10.0089 0.633777 9.98194 0.575918 9.92408C0.518059 9.86622 0.491059 9.78651 0.50263 9.7055L0.788067 7.7113ZM0.969359 7.16614L3.33386 9.53064L9.15189 3.71132L6.78867 1.34811L0.969359 7.16614ZM10.4248 2.07456L8.42544 0.0752165C8.32515 -0.0250722 8.16186 -0.0250722 8.06157 0.0752165L7.15254 0.984244L9.51576 3.34746L10.4248 2.43843C10.5251 2.33814 10.5251 2.17485 10.4248 2.07456Z" fill="#7351FD"/>
        </svg>
    );

    const handleSend = async () => {
        if (input.trim() === '') return;

        const newMessage = { text: input, sender: "me" };
        const updatedMessages = [...messages, newMessage];
        setMessages(updatedMessages);
        setInput('');
        setIsBotTyping(true);

        try {
            const response = await sendToAi(input);
            setPendingBotMessage({ text: response, sender: "bot" });
        } catch (error) {
            setPendingBotMessage({ text: error.message, sender: "bot" });
        }
    };

    const sendToAi = async (message) => {
        const response = await fetch('https://my.easycommerce.dev/wp-json/easysuite/v1/ai/ask', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'email': user.email

            },
            body: JSON.stringify({ question: message }),
        });

        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        return data.data || "No answer found";
    };

    const TypingText = ({ text, speed = 20, onComplete }) => {
        const [displayedText, setDisplayedText] = useState('');

        useEffect(() => {
            let currentIndex = 0;
            const intervalId = setInterval(() => {
                setDisplayedText((prev) => prev + text[currentIndex]);
                currentIndex++;
                if (currentIndex >= text.length) {
                    clearInterval(intervalId);
                    if (onComplete) onComplete();
                }
            }, speed);
            return () => clearInterval(intervalId);
        }, [text, speed, onComplete]);

        return <div dangerouslySetInnerHTML={{ __html: displayedText }}></div>;
    };

    useEffect(() => {
        if (inputRef.current) inputRef.current.focus();
    }, []);

    return (
        <div className="flex flex-col h-full justify-between font-inter">
            {messages.length === 0 && <Welcome />}

            {(messages.length > 0 || isBotTyping) && (
                <div className="easycommerce-ai-chatbox-container pr-5 flex flex-col overflow-y-scroll max-h-[65vh]">
                    {messages.map((msg, index) => (
                        <div key={index}>
                            {msg.sender === "me" ? (
                                <div className="flex flex-col gap-2 mb-4 group">
                                    <div className="max-w-[310px] ml-auto block text-sm text-ec-title bg-[#7351FD08] border border-ec-table-stock rounded-full py-[10px] px-5">
                                        {msg.text}
                                    </div>
                                    <div className="flex gap-2 justify-end opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                        {/*<button
                                            className="bg-[#7351FD08] rounded flex items-center justify-center w-5 h-5"
                                            onClick={() => navigator.clipboard.writeText(msg.text)}
                                        >
                                            {copyIcon}
                                        </button>*/}
                                        {/*<button
                                            className="bg-[#7351FD08] rounded flex items-center justify-center w-5 h-5"
                                            onClick={() => {
                                                setInput(msg.text);
                                                inputRef.current?.focus();
                                            }}
                                        >
                                            {editIcon}
                                        </button>*/}
                                    </div>
                                </div>
                            ) : (
                                <div className="mb-8">
                                    <div className="block text-sm text-ec-title pb-2 mb-2 border-ec-table-stock">
                                        <div dangerouslySetInnerHTML={{ __html: msg.text }}></div>
                                    </div>
                                    {/*<div className="flex gap-2">
                                        <button
                                            className="bg-[#7351FD08] rounded flex items-center justify-center w-5 h-5"
                                            onClick={() => navigator.clipboard.writeText(msg.text)}
                                        >
                                            {copyIcon}
                                        </button>
                                    </div>*/}
                                </div>
                            )}
                        </div>
                    ))}

                    {isBotTyping && pendingBotMessage && (
                        <div className="mb-8">
                            <div className="block text-sm text-ec-title pb-2 mb-2 border-ec-table-stock">
                                <TypingText
                                    text={pendingBotMessage.text}
                                    speed={10}
                                    onComplete={() => {
                                        setMessages((prev) => [...prev, pendingBotMessage]);
                                        setIsBotTyping(false);
                                        setPendingBotMessage(null);
                                    }}
                                />
                            </div>
                            {/*<div className="flex gap-2">
                                <button
                                    className="bg-[#7351FD08] rounded flex items-center justify-center w-5 h-5"
                                    onClick={() => navigator.clipboard.writeText(pendingBotMessage.text)}
                                >
                                    {copyIcon}
                                </button>
                            </div>*/}
                        </div>
                    )}
                </div>
            )}

            <div className="px-4 py-2 rounded-xl border border-ec-table-stock flex items-center justify-between gap-4">
                <input
                    ref={inputRef}
                    type="text"
                    placeholder="Ask me anything..."
                    className="border-0 outline-0 shadow-none p-0 grow font-inter"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleSend()}
                />
                <button onClick={handleSend} className="bg-transparent border-0 p-0">
                    {sendIcon}
                </button>
            </div>
        </div>
    );
};

export default AiChat;
